import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, onlineShopGoodsFind, createOnlineShopGoods, updateOnlineShopGoods, getGoodsCategoryList, getOnlineShopAreaList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { getTicketRuleList } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { removeImgUrlSuffix } from '@/utils/stringFun';
import { mapGetters } from 'vuex';
import UploadImage from '@/components/upload/image';
import GoodsSelectComponent from '@/view/bianlidianManage/goods/goodsSelectComponent';
import Draggable from 'vuedraggable';

var _this;

export default {
  name: 'OnlineShopAddGoods',
  components: {
    UploadImage: UploadImage,
    GoodsSelectComponent: GoodsSelectComponent,
    Draggable: Draggable
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      goodsTableData: [],
      formData: {},
      addBannerImgUrl: '',
      addDetailImgUrl: '',
      goodsSize: [],
      goodsSizeValue: '',
      goodsSizeVisible: false,
      sellerOptions: [],
      sellerCheckAll: false,
      goodsTicketOptions: [],
      goodsTicketOptionsOrigin: [],
      oilTicketOptions: [],
      oilTicketOptionsOrigin: [],
      ticketRuleTypeOptions: [{
        label: '加油券',
        value: 2
      }, {
        label: '便利店券',
        value: 3
      }],
      goodsComponentFormData: {
        dialogVisible: false,
        sellerId: 0,
        selection: [] // 回显，如果有数据，组件默认勾选

      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var goodsTicketOptions, oilTicketOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              debugger;
              console.log('AddGoods activated');
              _context.next = 4;
              return getTicketRuleList({
                page: 1,
                pageSize: 20,
                ruleType: 3,
                donNotShowLoading: true
              });

            case 4:
              goodsTicketOptions = _context.sent;
              _this.goodsTicketOptions = goodsTicketOptions.data.list;
              _this.goodsTicketOptionsOrigin = goodsTicketOptions.data.list;
              _context.next = 9;
              return getTicketRuleList({
                page: 1,
                pageSize: 20,
                ruleType: 2,
                donNotShowLoading: true
              });

            case 9:
              oilTicketOptions = _context.sent;
              _this.oilTicketOptions = oilTicketOptions.data.list;
              _this.oilTicketOptionsOrigin = oilTicketOptions.data.list;

              if (_this.$route.params.action === 'add') {
                _this2.formData = localStorage.getItem('onlineShopAddGoods') ? JSON.parse(localStorage.getItem('onlineShopAddGoods')) : _this2.initData();
              }

              if (_this.$route.params.action === 'update' && _this.searchInfo.goodsDetailNo !== _this.$route.params.goodsDetailNo) {
                _this.searchInfo = _this.$route.params;
                _this2.formData = _this2.initData();

                _this2.handleFindDetail(_this.searchInfo.goodsDetailNo);
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  deactivated: function deactivated() {
    this.onCache();
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var sellerOptions;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('AddGoods created');
              _this3.formData = _this3.initData();
              debugger;
              _context2.next = 5;
              return getSellerList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 5:
              sellerOptions = _context2.sent;
              _this3.sellerOptions = sellerOptions.data.list;
              _this3.formData.sellerId = _this3.sellerOptions[0].sellerId;

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        sellerId: 0,
        goodsDetailTitle: '',
        logisticsTypes: '2',
        logisticsSellerIds: [],
        isHot: 2,
        isRecommend: 2,
        weight: 0,
        categoryNo: '',
        bannerImgs: [],
        goodsDetailImgs: [],
        goodsList: [],
        showAreaList: [],
        activityTypes: '',
        // '1=返券 2=返积分，英文逗号分割，无活动就是空字符串'
        giveTicketLimit: "1\u3001\u5546\u54C1\u552E\u540E\u7533\u8BF7\u9000\u6B3E\u65F6\uFF0C\u4F18\u60E0\u5238\u9700\u9000\u56DE\n2\u3001\u5982\u5546\u54C1\u7533\u8BF7\u9000\u6B3E\u65F6\u4F18\u60E0\u5238\u5DF2\u4F7F\u7528\uFF0C\u9700\u4EE5\u5546\u54C1\u5B9E\u4ED8\u91D1\u989D\u51CF\u53BB\u5DF2\u4F7F\u7528\u5238\u989D\u4F5C\u4E3A\u5B9E\u9645\u8D54\u4ED8\u91D1\u989D\u8BA1\u7B97\u6807\u51C6\uFF0C\u5177\u4F53\u4E0E\u5BA2\u670D\u534F\u5546\u5904\u7406\n3\u3001\u8FD4\u8FD8\u7684\u6CB9\u5238\u767E\u6DA6\u65D7\u4E0B\u6CB9\u7AD9\u5747\u53EF\u7528\uFF1B\u6C7D\u6CB9\u3001\u67F4\u6CB9\u5747\u53EF\u7528\uFF1B\u6839\u636E\u5238\u89C4\u5219\u6BCF\u6EE1\u4E00\u5B9A\u91D1\u989D\u5373\u53EF\u53E0\u52A0\u4F7F\u7528\n4\u3001\u8FD4\u8FD8\u7684\u5546\u54C1\u5238\u4EC5\u9650\u767E\u6DA6\u65D7\u4E0B\u6CB9\u7AD9\u4FBF\u5229\u5E97\u4F7F\u7528\uFF1B\u6839\u636E\u5238\u89C4\u5219\u6BCF\u6EE1\u4E00\u5B9A\u91D1\u989D\u5373\u53EF\u53E0\u52A0\u4F7F\u7528\n5\u3001\u8FD4\u8FD8\u5238\u8FC7\u671F\u4F5C\u5E9F\uFF0C\u4E0D\u627E\u96F6\u3001\u4E0D\u5151\u73B0\u3001\u4E0D\u8BBE\u9000\u6362\n6\u3001\u6700\u7EC8\u89E3\u91CA\u6743\u5F52\u5546\u5BB6\u6240\u6709",
        selActivityGoodsItem: {}
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 显示大小尺寸输入框
    onShowInputSize: function onShowInputSize(row, ref) {
      var _this4 = this;

      if (row) {
        row.goodsSizeVisible = true;
      } else {
        this.goodsSizeVisible = true;
      }

      this.$nextTick(function (_) {
        _this4.$refs[ref] && _this4.$refs[ref].focus && _this4.$refs[ref].focus();
        _this4.$refs[ref] && _this4.$refs[ref][0].focus && _this4.$refs[ref][0].focus();
      });
    },
    // 添加大小尺寸
    onAddSize: function onAddSize(row) {
      var _this5 = this;

      if (row) {
        row.goodsSizeVisible = false;
        this.goodsSizeValue.trim() !== '' && row.size.push(this.goodsSizeValue);
      } else {
        this.goodsSizeVisible = false;
        this.goodsSizeValue.trim() !== '' && this.goodsSize.push(this.goodsSizeValue);
        this.goodsSizeValue.trim() !== '' && this.formData.goodsList.forEach(function (item) {
          item.size.push(_this5.goodsSizeValue);
        });
      }

      this.goodsSizeValue = '';
    },
    // 删除大小尺寸
    onDeleteSize: function onDeleteSize(row, index) {
      var _this6 = this;

      if (row) {
        row.size.splice(index, 1);
      } else {
        this.formData.goodsList.forEach(function (item) {
          item.size = item.size.filter(function (item2) {
            return item2 !== _this6.goodsSize[index];
          });
        });
        this.goodsSize.splice(index, 1);
      }
    },
    // 上传成功
    goodsBannerUploadSuccess: function goodsBannerUploadSuccess(res) {
      this.formData.bannerImgs.push(res.data.file.url);
      this.goodsBannerUploadSort();
    },
    // 上传成功
    goodsDetailUploadSuccess: function goodsDetailUploadSuccess(res) {
      this.formData.goodsDetailImgs.push(res.data.file.url);
      this.goodsDetailUploadSort();
    },
    goodsBannerUploadSort: function goodsBannerUploadSort() {
      this.formData.bannerImgs.sort(function (x, y) {
        return x.localeCompare(y, 'zh-Hans-CN');
      });
    },
    goodsDetailUploadSort: function goodsDetailUploadSort() {
      this.formData.goodsDetailImgs.sort(function (x, y) {
        return x.localeCompare(y, 'zh-Hans-CN');
      });
    },
    // 删除banner图
    onDeleteBanner: function onDeleteBanner(index) {
      var that = this;
      that.formData.bannerImgs.splice(index, 1);
    },
    // 删除商品图
    onDeleteDetailImg: function onDeleteDetailImg(index) {
      var that = this;
      that.formData.goodsDetailImgs.splice(index, 1);
    },
    // 添加图片链接
    onAddImgUrl: function onAddImgUrl(target) {
      if (target === 'bannerImgs' && this.addBannerImgUrl.trim() != '') {
        this.formData.bannerImgs.push(removeImgUrlSuffix(this.addBannerImgUrl.trim()));
      }

      if (target === 'goodsDetailImgs' && this.addDetailImgUrl.trim() != '') {
        this.formData.goodsDetailImgs.push(removeImgUrlSuffix(this.addDetailImgUrl.trim()));
      }

      this.addBannerImgUrl = '';
      this.addDetailImgUrl = '';
    },
    // 店铺全选
    handleSellerCheckAllChange: function handleSellerCheckAllChange(val) {
      this.formData.logisticsSellerIds = val ? this.sellerOptions.map(function (w) {
        return w.sellerId;
      }) : [];
      this.sellerCheckAll = this.formData.logisticsSellerIds.length === this.sellerOptions.length;
    },
    handleCheckedSellerChange: function handleCheckedSellerChange(value) {
      this.sellerCheckAll = value.length === this.sellerOptions.length;

      if (this.sellerCheckAll) {
        this.handleSellerCheckAllChange(true);
      }
    },
    // 添加商品
    onAddGoods: function onAddGoods() {
      this.goodsComponentFormData.dialogVisible = true;
      this.goodsComponentFormData.sellerId = this.formData.sellerId;
    },
    // 删除活动商品
    onDelGoods: function onDelGoods(row) {
      this.formData.goodsList = this.formData.goodsList.filter(function (item) {
        return item.spuNo != row.spuNo;
      });
      this.onCheckedActivityGoodsItem();
    },
    // 选择商品-确定
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      var _this7 = this;

      this.goodsComponentFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          item.imgUrl = item.goodsImg;
          item.goodsNum = 1;
          item.size = JSON.parse(JSON.stringify(_this7.goodsSize));
          item.goodsSizeVisible = false;
          item.titleSub = item.goodsName + '【' + item.goodsSpecification + '/' + item.goodsUnit + '】';
          item.goodsTicket = [_this7.initTicketSingle()];
          item.checked = false;
          item.activityTags = [];
          item.activityRemark = [];

          if (!_this7.formData.goodsList.some(function (item2) {
            return item2.spuNo === item.spuNo;
          })) {
            _this7.formData.goodsList.push(JSON.parse(JSON.stringify(item)));
          }
        });
      }

      this.onCheckedActivityGoodsItem();
    },
    // 选择商品-关闭
    goodsSelDialogClose: function goodsSelDialogClose() {
      this.goodsComponentFormData.dialogVisible = false;
    },
    // 活动配置-选中商品
    onCheckedActivityGoodsItem: function onCheckedActivityGoodsItem(goodsItem) {
      var _this8 = this;

      if (goodsItem) {
        // 指定选中
        this.formData.goodsList.forEach(function (item) {
          item.checked = false;
        });
        goodsItem.checked = true;
        this.formData.selActivityGoodsItem = goodsItem;
        return;
      }

      var selIsExit = false;
      this.formData.goodsList.forEach(function (item) {
        if (item.spuNo === _this8.formData.selActivityGoodsItem.spuNo) {
          selIsExit = true;
        }
      }); // 已选中是否还存在，不存在默认选第一个

      if (!selIsExit && this.formData.goodsList.length > 0) {
        this.onCheckedActivityGoodsItem(this.formData.goodsList[0]);
        return;
      } else {
        this.formData.selActivityGoodsItem = {};
      }

      return;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        ticketName: '',
        ruleType: 2,
        // 2=油品券 3=商品券
        ticketType: 0,
        // 1=满减 2=折扣 3=现金 4=单升
        ticketValue: 0,
        // 1=满减 2=折扣 3=现金 4=单升
        num: 1,
        oilTicketOptions: this.oilTicketOptionsOrigin,
        goodsTicketOptions: this.goodsTicketOptionsOrigin
      };
    },
    // 添加油品券
    onAddTicket: function onAddTicket() {
      this.formData.selActivityGoodsItem.goodsTicket.push(this.initTicketSingle());
    },
    // 删除油品券
    onDeleteTicket: function onDeleteTicket(index) {
      this.formData.selActivityGoodsItem.goodsTicket.splice(index, 1);

      if (this.formData.selActivityGoodsItem.goodsTicket.length === 0) {
        this.formData.selActivityGoodsItem.goodsTicket.push(this.initTicketSingle());
      }

      this.autoCreateActivityInfo();
    },
    // 选中优惠券
    onSelTicket: function onSelTicket(ticketRuleNo, ticketItem) {
      var ticket = ticketItem.oilTicketOptions.concat(ticketItem.goodsTicketOptions).filter(function (item) {
        return item.ticketRuleNo === ticketRuleNo;
      })[0];

      if (ticket) {
        ticketItem.ruleType = ticket.ruleType;
        ticketItem.ticketType = ticket.ticketType;
        ticketItem.ticketValue = ticket.ticketValue;
        ticketItem.ticketName = ticket.ticketName;
      }

      this.autoCreateActivityInfo();
    },
    autoCreateActivityInfo: function autoCreateActivityInfo() {
      var _this9 = this;

      var oilTicketGroup1 = this.formData.selActivityGoodsItem.goodsTicket.filter(function (item) {
        return item.ticketRuleNo && item.ruleType == 2 && [1, 3].includes(item.ticketType);
      }); // 加油券、满减/现金

      var oilTicketGroup2 = this.formData.selActivityGoodsItem.goodsTicket.filter(function (item) {
        return item.ticketRuleNo && item.ruleType == 2 && [2].includes(item.ticketType);
      }); // 折扣

      var oilTicketGroup3 = this.formData.selActivityGoodsItem.goodsTicket.filter(function (item) {
        return item.ticketRuleNo && item.ruleType == 2 && [4].includes(item.ticketType);
      }); // 单升

      var goodsTicketGroup1 = this.formData.selActivityGoodsItem.goodsTicket.filter(function (item) {
        return item.ticketRuleNo && item.ruleType == 3 && [1, 3].includes(item.ticketType);
      }); // 商品券、满减/现金

      var goodsTicketGroup2 = this.formData.selActivityGoodsItem.goodsTicket.filter(function (item) {
        return item.ticketRuleNo && item.ruleType == 3 && [2].includes(item.ticketType);
      }); // 折扣

      this.formData.selActivityGoodsItem.activityTags = [];

      if (oilTicketGroup1.length > 0) {
        var activityTag = {
          tagType: 1,
          // 1=返券活动 2=返积分活动
          tagIcon: '返',
          tagName: '元油券',
          tagValue: 0
        };
        oilTicketGroup1.forEach(function (item) {
          activityTag.tagValue += item.ticketValue * item.num;
        });
        activityTag.tagValue = activityTag.tagValue.toFixed(2);
        this.formData.selActivityGoodsItem.activityTags.push(activityTag);
      }

      if (oilTicketGroup2.length > 0) {
        oilTicketGroup2.forEach(function (item) {
          var activityTag = {
            tagType: 1,
            // 1=返券活动 2=返积分活动
            tagIcon: '返',
            tagName: '折油券',
            tagValue: item.ticketValue
          };

          _this9.formData.selActivityGoodsItem.activityTags.push(activityTag);
        });
      }

      if (oilTicketGroup3.length > 0) {
        oilTicketGroup3.forEach(function (item) {
          var activityTag = {
            tagType: 1,
            // 1=返券活动 2=返积分活动
            tagIcon: '返',
            tagName: '/升油券',
            tagValue: item.ticketValue
          };

          _this9.formData.selActivityGoodsItem.activityTags.push(activityTag);
        });
      }

      if (goodsTicketGroup1.length > 0) {
        var _activityTag = {
          tagType: 1,
          // 1=返券活动 2=返积分活动
          tagIcon: '返',
          tagName: '元商品券',
          tagValue: 0
        };
        goodsTicketGroup1.forEach(function (item) {
          _activityTag.tagValue += item.ticketValue * item.num;
        });
        _activityTag.tagValue = _activityTag.tagValue.toFixed(2);
        this.formData.selActivityGoodsItem.activityTags.push(_activityTag);
      }

      if (goodsTicketGroup2.length > 0) {
        goodsTicketGroup2.forEach(function (item) {
          var activityTag = {
            tagType: 1,
            // 1=返券活动 2=返积分活动
            tagIcon: '返',
            tagName: '折商品券',
            tagValue: item.ticketValue
          };

          _this9.formData.selActivityGoodsItem.activityTags.push(activityTag);
        });
      }

      var activityRemark = [];
      this.formData.selActivityGoodsItem.goodsTicket.forEach(function (item) {
        if (item.ticketRuleNo && item.ruleType === 2) {
          activityRemark.push(item.ticketName + '*' + item.num + '张（油券）');
        }

        if (item.ticketRuleNo && item.ruleType === 3) {
          activityRemark.push(item.ticketName + '*' + item.num + '张（商品券）');
        }
      });
      this.formData.selActivityGoodsItem.activityRemark = activityRemark.join('；');
    },
    // 查看优惠券详情
    onViewTicket: function onViewTicket(item) {
      var params = {
        ticketRuleNo: item.ticketRuleNo
      };

      if (item.ruleType === 2) {
        this.$router.push({
          name: 'OilTicketConfig',
          params: params
        });
      }

      if (item.ruleType === 3) {
        this.$router.push({
          name: 'GoodsTicketConfig',
          params: params
        });
      }
    },
    // 选择券类型
    onTicketRuleTypeChange: function onTicketRuleTypeChange(item) {
      item.ticketRuleNo = '';
      item.num = 1;
      this.resetTicketOptions(item);
      this.autoCreateActivityInfo();
      this.$forceUpdate();
    },
    resetTicketOptions: function resetTicketOptions(item) {
      item.oilTicketOptions = this.oilTicketOptionsOrigin;
      item.goodsTicketOptions = this.goodsTicketOptionsOrigin;
    },
    // 远程搜索优惠券
    onSearchTicket: function onSearchTicket(item, text) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ticketOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this10.resetTicketOptions(item);

                if (text.trim()) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return getTicketRuleList({
                  page: 1,
                  pageSize: 10,
                  ruleType: item.ruleType,
                  ticketName: text.trim(),
                  donNotShowLoading: true
                });

              case 5:
                ticketOptions = _context3.sent;

                if (item.ruleType === 2) {
                  // 加油券
                  item.oilTicketOptions = ticketOptions.data.list;
                }

                if (item.ruleType === 3) {
                  // 商品券
                  item.goodsTicketOptions = ticketOptions.data.list;
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 商品详情查询
    handleFindDetail: function handleFindDetail(goodsDetailNo) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var detailRes, ticketRuleNoMap, key, ticketOptions;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return onlineShopGoodsFind({
                  'goodsDetailNo': goodsDetailNo
                });

              case 2:
                detailRes = _context4.sent;
                _this11.formData.sellerId = detailRes.data.sellerId;
                _this11.formData.goodsDetailTitle = detailRes.data.goodsDetailTitle;
                _this11.formData.isHot = detailRes.data.isHot;
                _this11.formData.isRecommend = detailRes.data.isRecommend;
                _this11.formData.weight = detailRes.data.weight;
                _this11.formData.categoryNo = detailRes.data.categoryNo;
                _this11.formData.bannerImgs = detailRes.data.bannerImgs ? JSON.parse(detailRes.data.bannerImgs) : [];
                _this11.formData.goodsDetailImgs = detailRes.data.goodsDetailImgs ? JSON.parse(detailRes.data.goodsDetailImgs) : [];
                _this11.formData.giveTicketLimit = detailRes.data.giveTicketLimit;
                _this11.formData.logisticsTypes = detailRes.data.logisticsTypes;
                detailRes.data.logisticsSellerIds.split(',').forEach(function (item) {
                  _this11.formData.logisticsSellerIds.push(parseInt(item));
                });
                ticketRuleNoMap = {};
                detailRes.data.relationSpuNoList.forEach(function (item) {
                  item.giveTickets && JSON.parse(item.giveTickets).forEach(function (ticketItem) {
                    ticketItem.ticketRuleNo = Number(ticketItem.ticketRuleNo);
                    ticketRuleNoMap[ticketItem.ticketRuleNo + ''] = ticketItem.ruleType;
                  });
                });
                _context4.t0 = regeneratorRuntime.keys(ticketRuleNoMap);

              case 17:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 26;
                  break;
                }

                key = _context4.t1.value;
                _context4.next = 21;
                return getTicketRuleList({
                  page: 1,
                  pageSize: 2,
                  ruleType: ticketRuleNoMap[key],
                  ticketRuleNo: key,
                  donNotShowLoading: true
                });

              case 21:
                ticketOptions = _context4.sent;

                if (ticketRuleNoMap[key] === 2 && ticketOptions.data.list) {
                  // 加油券
                  _this11.oilTicketOptionsOrigin = _this11.oilTicketOptionsOrigin.concat(ticketOptions.data.list);
                }

                if (ticketRuleNoMap[key] === 3 && ticketOptions.data.list) {
                  // 商品券
                  _this11.goodsTicketOptionsOrigin = _this11.goodsTicketOptionsOrigin.concat(ticketOptions.data.list);
                }

                _context4.next = 17;
                break;

              case 26:
                detailRes.data.relationSpuNoList.forEach(function (item) {
                  var goodsTicket = [];
                  item.giveTickets && JSON.parse(item.giveTickets).forEach(function (ticketItem) {
                    ticketItem.ticketRuleNo = Number(ticketItem.ticketRuleNo);
                    ticketItem.oilTicketOptions = _this11.oilTicketOptionsOrigin;
                    ticketItem.goodsTicketOptions = _this11.goodsTicketOptionsOrigin;
                    goodsTicket.push(ticketItem);
                  });
                  var goodsItem = {
                    imgUrl: item.imgUrl,
                    goodsName: item.goodsName,
                    spuNo: item.spuNo,
                    goodsStock: item.goodsStock,
                    goodsLatestCost: item.goodsCost,
                    goodsPrice: item.goodsPrice,
                    goodsNum: 1,
                    size: item.size,
                    goodsSizeVisible: false,
                    titleSub: item.titleSub,
                    goodsTicket: goodsTicket.length > 0 ? goodsTicket : [_this11.initTicketSingle()],
                    activityTags: item.activityTags ? JSON.parse(item.activityTags) : [],
                    activityRemark: item.activityRemark,
                    checked: false
                  };

                  _this11.formData.goodsList.push(goodsItem);
                });

                _this11.onCheckedActivityGoodsItem(_this11.formData.goodsList[0]);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onCache: function onCache() {
      debugger;

      if (!this.searchInfo.goodsDetailNo) {
        localStorage.setItem('onlineShopAddGoods', JSON.stringify(this.formData));
      }
    },
    onClear: function onClear() {
      this.formData = this.initData();
      this.formData.sellerId = this.sellerOptions[0].sellerId;
      localStorage.removeItem('onlineShopAddGoods');
    },
    onSave: function onSave() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var activityTypes, relationSpuNoList, param, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this12.formData.goodsDetailTitle) {
                  _context5.next = 3;
                  break;
                }

                _this12.$message({
                  type: 'warning',
                  message: '详情页商品名称不能为空！'
                });

                return _context5.abrupt("return");

              case 3:
                if (!(_this12.formData.logisticsTypes.indexOf('1') !== -1 && _this12.formData.logisticsSellerIds.length === 0)) {
                  _context5.next = 6;
                  break;
                }

                _this12.$message({
                  type: 'warning',
                  message: '自提门店不能为空！'
                });

                return _context5.abrupt("return");

              case 6:
                if (!(_this12.formData.goodsList.length === 0)) {
                  _context5.next = 9;
                  break;
                }

                _this12.$message({
                  type: 'warning',
                  message: '关联商品不能为空！'
                });

                return _context5.abrupt("return");

              case 9:
                activityTypes = [];

                _this12.formData.goodsList.forEach(function (item) {
                  if (item.goodsTicket) {
                    item.goodsTicket.forEach(function (item2) {
                      if (item2.ticketRuleNo && !activityTypes.includes('1')) {
                        activityTypes.push('1');
                      }
                    });
                  }
                });

                relationSpuNoList = [];

                _this12.formData.goodsList.forEach(function (item) {
                  var giveTickets = [];
                  item.goodsTicket.forEach(function (ticketItem) {
                    if (ticketItem.ticketRuleNo) {
                      giveTickets.push({
                        'ruleType': ticketItem.ruleType,
                        'ticketType': ticketItem.ticketType,
                        'ticketRuleNo': ticketItem.ticketRuleNo + '',
                        'ticketName': ticketItem.ticketName,
                        'ticketValue': ticketItem.ticketValue,
                        'num': Number(ticketItem.num)
                      });
                    }
                  });
                  var goodsItem = {
                    spuNo: item.spuNo,
                    size: item.size,
                    imgUrl: item.imgUrl,
                    titleSub: item.titleSub,
                    giveTicketsRemark: '',
                    activityRemark: item.activityRemark,
                    activityTags: JSON.stringify(item.activityTags.map(function (item) {
                      item.tagValue = Number(item.tagValue);
                      return item;
                    })),
                    giveTickets: JSON.stringify(giveTickets)
                  };
                  relationSpuNoList.push(goodsItem);
                });

                param = {
                  goodsDetailNo: _this12.searchInfo.goodsDetailNo || '',
                  sellerId: _this12.formData.sellerId,
                  goodsDetailTitle: _this12.formData.goodsDetailTitle,
                  isHot: _this12.formData.isHot,
                  isRecommend: _this12.formData.isRecommend,
                  logisticsTypes: _this12.formData.logisticsTypes,
                  logisticsSellerIds: _this12.formData.logisticsTypes.indexOf('1') !== -1 ? _this12.formData.logisticsSellerIds.join(',') : '',
                  activityTypes: activityTypes.join(','),
                  goodsDetailImgs: JSON.stringify(_this12.formData.goodsDetailImgs),
                  bannerImgs: JSON.stringify(_this12.formData.bannerImgs),
                  giveTicketLimit: _this12.formData.giveTicketLimit,
                  relationSpuNoList: relationSpuNoList,
                  weight: _this12.formData.weight
                };
                res = {};

                if (_this12.searchInfo.goodsDetailNo) {
                  _context5.next = 21;
                  break;
                }

                _context5.next = 18;
                return createOnlineShopGoods(param);

              case 18:
                res = _context5.sent;
                _context5.next = 24;
                break;

              case 21:
                _context5.next = 23;
                return updateOnlineShopGoods(param);

              case 23:
                res = _context5.sent;

              case 24:
                if (res.code == 0) {
                  _this12.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this12.onClear();

                    _this12.goBack();
                  }, 300);
                }

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};